export const swiperBreakpointsOptions = {
  280: {
    width: 280,
    spaceBetween: -20,
    slidesPerView: 1,
    slidesPerGroup: 1,
  },
  380: {
    width: 340,
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
  },
  400: {
    width: 370,
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
  },
  500: {
    width: 500,
    spaceBetween: 240,
    slidesPerView: 2,
    slidesPerGroup: 1,
  },
  768: {
    width: 768,
    slidesPerView: 3,
    slidesPerGroup: 2,
    spaceBetween: 350,
  },
  1024: {
    width: 1024,
    spaceBetween: 250,
    slidesPerView: 3,
    slidesPerGroup: 2,
  },
  1280: {
    width: 1280,
    spaceBetween: 410,
    slidesPerView: 4,
    slidesPerGroup: 2,
  },
  1600: {
    width: 1600,
    spaceBetween: 100,
    slidesPerView: 4,
    slidesPerGroup: 3,
  },
  1900: {
    width: 1900,
    spaceBetween: 200,
    slidesPerView: 5,
    slidesPerGroup: 4,
  },
};
